// TODO 所有数学转介绍landingpage相关页面路由在此配置
// TODO 所有数学转介绍landingpage路由的path必须以 /landingpage/ 开头
// TODO 所有路由的name以及webpackChunkName必须以 landingpage 开头

export default [
  {
    path: '/landingpage',
    redirect: { name: 'landingpageInvite' }
  },
  {
    path: '/landingpage/introduce',
    name: 'landingpageIntroduce',
    component: () => import(/* webpackChunkName: "landingpageIntroduce" */ '@/views/landingpage/introduce.vue'),
    meta: {
      title: 'VIPKID在线青少儿数学思维'
    }
  },
  {
    path: '/landingpage/invite',
    name: 'landingpageInvite',
    component: () => import(/* webpackChunkName: "landingpageInvite" */ '@/views/landingpage/invite.vue'),
    meta: {
      title: 'VIPKID在线青少儿数学思维'
    }
  },
  {
    path: '/landingpage/invitechinese',
    name: 'inviteChinese',
    component: () => import(/* webpackChunkName: "chineseInvite" */ '@/views/landingpage/invite-chinese.vue'),
    meta: {
      title: 'VIPKID在线青少儿语文培优'
    }
  },
  {
    path: '/landingpage/chinesesuccess',
    name: 'chineseSuccess',
    component: () => import(/* webpackChunkName: "chineseInvite" */ '@/views/landingpage/chinese-success.vue'),
    meta: {
      title: 'VIPKID在线青少儿语文培优'
    }
  },
  {
    path: '/landingpage/success',
    name: 'landingpageSuccess',
    component: () => import(/* webpackChunkName: "landingpageInvite" */ '@/views/landingpage/invite-success.vue'),
    meta: {
      title: 'VIPKID在线青少儿数学思维'
    }
  },
  {
    path: '/landingpage/fail',
    name: 'landingpageFail',
    component: () => import(/* webpackChunkName: "landingpageInvite" */ '@/views/landingpage/invite-fail.vue'),
    meta: {
      title: 'VIPKID在线青少儿数学思维'
    }
  }
]
